import { Button } from "@component/button";
import { AlertTriangleIcon, XIcon } from "lucide-react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export function InterviewEndConfirmDialog(props: Props) {
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className={`rounded-xl shadow-lg max-w-md w-full p-6 relative bg-white`}>
                <button onClick={props.onClose} className={`absolute top-4 right-4 text-gray-500 hover:text-gray-700 `}>
                    <XIcon className="h-5 w-5" />
                </button>
                <div className="flex items-center gap-3 mb-4">
                    <div className={`bg-yellow-100  p-2 rounded-full`}>
                        <AlertTriangleIcon className={`h-6 w-6 text-yellow-600`} />
                    </div>
                    <h2 className={`text-xl font-bold text-gray-900 `}>
                        You’re almost there!
                    </h2>
                </div>
                <div className="mb-6">
                    <p className={`mb-4 text-gray-700 dark:text-gray-300`}>
                        Completing <b>at least 15 minutes</b> gives you the best chance to showcase skills beyond your CV.
                        <br /><br />
                        If you end now, your insights and visibility to recruiters will be limited.
                    </p>
                </div>
                <div className="flex justify-end gap-3">
                    <Button
                        type="button"
                        variant="outline"
                        onClick={props.onClose}
                        className={`w-full sm:w-auto`}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        onClick={props.onConfirm}
                        className="w-full sm:w-auto"
                    >
                        End Interview
                    </Button>
                </div>
            </div>
        </div>
    );
}